import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { useText } from 'common/hooks';
import { Form } from 'providers/Forms';
import { FormWrapper, Label, TextField, Button } from './elements';
import { ICON } from 'resources/constants';

const deps = {
  isSavingProfile: state.account.isSavingProfile,
  form: state.account.profileForm,
  profileFieldChanged: sequences`account.profileFieldChanged`,
  saveProfileClicked: sequences`account.saveProfileClicked`,
};

export function InfoForm({
  isSavingProfile,
  form,
  profileFieldChanged,
  saveProfileClicked,
  get,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  const profileForm = new Form(form, get) as any;

  return (
    <FormWrapper>
      <Label as={'label'} htmlFor={'first-name'}>
        {t('account.settings.profile.general_info.first_name')}
      </Label>
      <TextField
        id={'first-name'}
        placeholder={t('account.settings.profile.general_info.first_name')}
        whiteBG
        maxLength={26}
        errorMessage={
          (!profileForm.firstName.isPristine &&
            profileForm.firstName.errorMessage &&
            t(
              profileForm.firstName.errorMessage.phrase,
              profileForm.firstName.errorMessage.options
            )) ||
          null
        }
        onChange={e =>
          profileFieldChanged({
            path: 'account.profileForm.firstName',
            value: e.target.value,
          })
        }
        value={profileForm.firstName.value}
        icon={ICON.person}
      />
      <Label as={'label'} htmlFor={'last-name'}>
        {t('account.settings.profile.general_info.last_name')}
      </Label>
      <TextField
        id={'last-name'}
        placeholder={t('account.settings.profile.general_info.last_name')}
        whiteBG
        maxLength={26}
        onChange={e =>
          profileFieldChanged({
            path: 'account.profileForm.lastName',
            value: e.target.value,
          })
        }
        value={profileForm.lastName.value}
        icon={ICON.person}
      />
      <Label as={'label'} htmlFor={'email'}>
        {t('account.settings.profile.general_info.email')}
      </Label>
      <TextField
        id={'email'}
        placeholder={t('account.settings.profile.general_info.email')}
        whiteBG
        disabled
        value={profileForm.email.value}
        icon={ICON.person}
      />
      <Button
        disabled={
          !profileForm.isValid ||
          isSavingProfile ||
          Object.values(profileForm).every(({ isPristine }) => isPristine)
        }
        onClick={() => saveProfileClicked()}
      >
        {t('account.settings.profile.general_info.save')}
      </Button>
    </FormWrapper>
  );
}

export default connect(deps, InfoForm);
